import { render, staticRenderFns } from "./CustomNotice.vue?vue&type=template&id=2db74168&scoped=true&"
import script from "./CustomNotice.vue?vue&type=script&lang=js&"
export * from "./CustomNotice.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotice.vue?vue&type=style&index=0&id=2db74168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db74168",
  null
  
)

export default component.exports